module.exports = __webpack_public_path__ + "img/logo.53ae6c78.png";